import React from "react";
import PreviewCard from "./PreviewCard";
import Stack from "./Stack";
import config from "../assets/config"; // Import the config file
import useFirestoreCollection, { projectFromDoc } from "./useFirestoreCollection";
import useResponsive from "./useResponsive";
import useServiceBadge from "./useServiceBadge";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import CardGallery from "./CardGallery";
function ProjectsPage() {
	const projects = useFirestoreCollection("projects_public", projectFromDoc)
		.filter((project) => project.visibility)
		.sort((a, b) => (b.year ?? 0) - (a.year ?? 0));
    const extProjects = useFirestoreCollection("collaborations").filter(
		(project) => project.visibility
	);
	const navigate = useNavigate();
	const isMobile = useResponsive();
	const { t } = useTranslation();
	const getServiceBadge = useServiceBadge();
	return (
		<div>
            <div style={{height:"90px"}}></div>
			<Stack
				direction="h"
				titleLevel="h1"
				titlestyle={{ color: "white" }}
				enableScrollButtons="true"
				config={config}
			>
				{projects.map((card) => (
					<PreviewCard
						key={card.id}
						image={card.image ? `${process.env.PUBLIC_URL}/content/projects/${card.nameid}/${card.image}` : undefined}
						title={card.title}
						description={card.description}
						config={config}
						style={{
							backgroundColor: "rgba(255,255,255,0.95)",
							...(isMobile
								? {
										minWidth: "90vw",
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
								  }
								: {}),
						}}
						buttonText={t(card.buttonText)}
						onButtonClick={() => navigate(`/projects/${card.nameid}`)}
						direction={"v"}
						imageStyle={{
							aspectRatio: "4/3",
							maxWidth: isMobile ? "60vh" : "600px",
							...(isMobile ? { width: "100%", margin: "auto" } : {}),
						}}
						itemsStyle={{
							margin: "auto",
							width: "100%",
							height: "100%",
							display: "flex",
							padding: "10px",
						}}
						notificationImage={getServiceBadge(card)}
					/>
				))}
			</Stack>
            <h1 style={{ color: config.colors.accent,whiteSpace: 'pre-wrap',textAlign:'center', margin:'0px',backgroundColor: config.colors.darkAccent,padding:"10px"}}>Collaborations</h1>
			<CardGallery style={{backgroundColor: config.colors.darkAccent}} modalEnabled={true} cards={extProjects} />
		</div>
	);
}

export default ProjectsPage;

// Repeat for Gallery.js and Contact.js with appropriate content changes
